import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { blue600, Text } from '@paypalcorp/pp-react'
import { smallAndSmaller } from 'lib/styles/media-queries'

const ChangeIcon = glamorous.span({
  display: 'none',
  [smallAndSmaller]: {
    display: 'block',
  },
})

const ChangeText = glamorous(props => (
  <Text as="span" size="md" medium {...props} />
))({
  color: blue600,
  fontFamily: '"PayPalSansSmall-Regular", Helvetica Neue, Arial, sans-serif',
  fontWeight: 700,
  display: 'block',
  [smallAndSmaller]: {
    display: 'none',
  },
})

const ChangeTextOrIcon = ({ text }) => {
  return (
    <React.Fragment>
      <ChangeIcon className="ppvx_icon ppvx_icon--size_sm ppvx_icon-chevron-right" />
      <ChangeText>{text}</ChangeText>
    </React.Fragment>
  )
}

ChangeTextOrIcon.propTypes = {
  text: PropTypes.string.isRequired,
}

export default ChangeTextOrIcon
